function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["onSelectAll", "checked", "disabled", "onChange", "className", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import PropTypes from "prop-types";
import { noop } from "lodash-es";
import classNames from "classnames";
import { onSpace } from "../../helpers";
import { CheckBox as Checked, CheckBoxOutlineBlank as Unchecked, IndeterminateCheckBox as Indeterminate } from "../../icons";
var CheckboxIcon = function CheckboxIcon(_ref) {
  var _ref$onSelectAll = _ref.onSelectAll,
    onSelectAll = _ref$onSelectAll === void 0 ? noop : _ref$onSelectAll,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onChange = _ref.onChange,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var icon;
  if (checked === "mixed") {
    icon = /*#__PURE__*/React.createElement(Indeterminate, null);
  } else if (checked) {
    icon = /*#__PURE__*/React.createElement(Checked, null);
  } else {
    icon = /*#__PURE__*/React.createElement(Unchecked, null);
  }
  function onClick(event) {
    var status = false;
    if (checked === "mixed") {
      status = true;
      onSelectAll();
    } else {
      status = !checked;
    }
    if (onChange) {
      onChange(status, event);
    }
  }
  return /*#__PURE__*/React.createElement("span", _extends({
    tabIndex: disabled ? -1 : 0,
    role: "checkbox",
    "aria-checked": (checked !== null && checked !== void 0 ? checked : false).toString(),
    "aria-disabled": disabled
  }, !disabled && {
    onClick: onClick,
    onKeyPress: onSpace(onClick)
  }, props, {
    className: classNames("checkbox-icon", _defineProperty({
      unchecked: checked === false,
      disabled: disabled
    }, className, className))
  }), icon, children);
};
CheckboxIcon.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.oneOf([true, false, "mixed"]),
  onSelectAll: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  onChange: PropTypes.func
};
export default CheckboxIcon;
//# sourceMappingURL=CheckboxIcon.js.map